import styles from "./multistepForm.module.scss";
import { Box } from "@mui/material";
import Button from "../buttons/Buttons";
import PropTypes from "prop-types";

const FormFooterSection = (props) => {
  return (
    <Box
      className={styles.footerSectionWrapper}
      data-testid="FormFooterSection"
    >
      <Box className={styles.leftSection}>
        {props.hasPrevious && (
          <Button
            title="Back"
            iconStyle={styles.Back}
            buttonType="muibtn-secondary-with-border"
            attriType={"button"}
            withIcon={true}
            handleClick={props.onBackClick}
          />
        )}
      </Box>
      <Box className={styles.rightSection}>
        <Button
          title="Cancel"
          iconStyle={""}
          buttonType="muibtn-secondary"
          withIcon={false}
          attriType={"button"}
          handleClick={props.onCancel}
        />

        <Button
          title={props.isLastStep ? "Submit" : "Next"}
          iconStyle={styles.save}
          buttonType={
            props.isLastStep
              ? "muibtn-primary"
              : "muibtn-primary-with-right-icon"
          }
          withIcon={!props.isLastStep}
          attriType={"submit"}
          handleClick={() => props.onSubmit}
          classList={"withRightIcon"}
        />

      </Box>
    </Box>
  );
};

export default FormFooterSection;
FormFooterSection.propTypes = {
  hasPrevious:PropTypes.any,
  onBackClick:PropTypes.any,
  onCancel:PropTypes.any,
  isLastStep:PropTypes.any,
  onSubmit:PropTypes.any
}